<template>
  <el-dialog title="Alterar Taxa de Adm." :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="300px">
    <el-form ref="form" :model="aluguelRecuperado" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Aluguel">
            <el-input v-model="aluguelRecuperado.idNaImobiliaria" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Comissão (%)" prop="comissao">
            <div class="el-input el-input--small">
              <money v-model="aluguelRecuperado.comissao" v-bind="percent" class="el-input__inner" />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mês série" prop="primeiroMesSerie">
            <el-input v-model="aluguelRecuperado.primeiroMesSerie" v-mask="'###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-checkbox v-model="aluguelRecuperado.somenteMesSerieSelecionado" label="Somente para o mês selecionado"></el-checkbox>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="aluguelRecuperado.somenteMesSerieSelecionado">
        <el-col :span="24">
          <el-form-item>
            <el-checkbox v-model="aluguelRecuperado.taxaAdministracaoComplementar" label="Taxa de administração extra"></el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="aluguelRecuperado.somenteMesSerieSelecionado">
        <el-col :span="24">
          <el-form-item>
              <strong>{{ 'Última taxa de administração extra' }}</strong>
              <strong>{{ labelUltimaTaxaAdministracaoComplementar }}</strong>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="alterarTaxaAdministracaoHandler" type="primary" size="small" round class="btn-box-shadow">Alterar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { Money } from 'v-money';

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },

  components: {
    Money,
  },

  data() {
    return {
      aluguelRecuperado: {},
      labelUltimaTaxaAdministracaoComplementar: '',

      validacao: {
        comissao: [{ required: true }, {type: 'number', max: 100}],
        primeiroMesSerie: [{ required: true }]
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false,
        min: 0.0,
        max: 100
      },
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
      'ultimaTaxaAdministracaoComplementar',
      'alterarTaxaAdministracao'
    ]),
    iniciar() {
      this.aluguelRecuperado = {
        ...this.aluguel,
        somenteMesSerieSelecionado: false,
        taxaAdministracaoComplementar: false
      }
      this.recuperarUltimaTaxaAdministracaoComplementarHandler()
    },
    recuperarUltimaTaxaAdministracaoComplementarHandler(){
      let payload = { id: this.aluguelRecuperado.imovel.id }

      this.showLoading();
      this.ultimaTaxaAdministracaoComplementar(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.labelUltimaTaxaAdministracaoComplementar = resultado.dataVencimento + " (" + resultado.aluguel.idNaImobiliaria + ") "
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    alterarTaxaAdministracaoHandler(){
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.showLoading();
          this.alterarTaxaAdministracao(this.aluguelRecuperado)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              default:
                this.$message.warning(resultado.mensagem);
                break;
            }
            this.fechar();
          }).catch(() => {
            this.fechar();
            this.hideLoading();
          });
        }
      });
    },
    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
